import { render, staticRenderFns } from "./HeadquartersInfo.vue?vue&type=template&id=2c415a5e&scoped=true"
import script from "./HeadquartersInfo.vue?vue&type=script&lang=js"
export * from "./HeadquartersInfo.vue?vue&type=script&lang=js"
import style0 from "./HeadquartersInfo.vue?vue&type=style&index=0&id=2c415a5e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c415a5e",
  null
  
)

export default component.exports